import {
  usePromotionsQuery,
  UsePromotionsQueryParams,
} from "../queries/usePromotionsQuery";
import { IPagination } from "../../../interfaces/IPagination";
import { PromotionType } from "../../../interfaces/promotionType";

type Response = {
  promotions: PromotionType[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const usePromotions = (opt: UsePromotionsQueryParams): Response => {
  const { data, isLoading } = usePromotionsQuery(opt);
  return {
    promotions: data?.data?.promotions || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
